module.exports = __webpack_public_path__ + "img/sunyun_title.f318219e.png";